<div id="earth-bg" class="forgot-container bg-light">
  <div class="forgot-box">
    <div class="container">
      <div class="card col-md-6 mt-3 mx-auto">
        <div class="card-body">
          <div style="display: flex; align-items: center; gap: 16px;">
            <mat-spinner diameter="32"></mat-spinner>
            <h4 style="margin: 0;">Signing you in&hellip;</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
